export const arrayToRecord = (array, mapper) => {
    const result = {};
    for (const item of array) {
        const entry = mapper(item);
        if (entry !== undefined) {
            const [key, value] = entry;
            result[key] = value;
        }
    }
    return result;
};
export const recordToArray = (record, mapper) => {
    const result = [];
    for (const [key, value] of Object.entries(record)) {
        if (value !== undefined) {
            const item = mapper(value, key);
            if (item !== undefined) {
                result.push(item);
            }
        }
    }
    return result;
};
export const arrayFilterMap = (array, filterMapper) => {
    const result = [];
    for (let index = 0; index < array.length; index++) {
        const item = array[index];
        const entry = filterMapper(item, index);
        if (entry !== undefined) {
            result.push(entry);
        }
    }
    return result;
};
export const arrayFilterCatchMap = (array, filterMapper, onCatch) => {
    const result = [];
    for (const item of array) {
        try {
            const entry = filterMapper(item);
            if (entry !== undefined) {
                result.push(entry);
            }
        }
        catch (error) {
            onCatch(error, item);
        }
    }
    return result;
};
export const arrayFindMap = (array, predicate, mapper) => {
    for (const item of array) {
        if (predicate(item)) {
            return mapper(item);
        }
    }
    return undefined;
};
export const arrayPartitionById = (array, idKey, idValue) => {
    return arrayPartitionByPredicate(array, (obj) => obj[idKey] === idValue);
};
export const arrayPartitionByPredicate = (array, predicate) => {
    const idx = array.findIndex(predicate);
    if (idx === -1) {
        return undefined;
    }
    const before = array.slice(0, idx);
    const element = array[idx];
    const after = array.slice(idx + 1);
    return {
        before,
        element,
        after,
    };
};
export const arraySortValues = (array, ordinalFn) => array.slice().sort((a, b) => ordinalFn(a) - ordinalFn(b));
export const arrayGroupToMap = (array, propKey, mapper) => {
    return array.reduce((result, item) => {
        const keyValue = item[propKey];
        const resultItem = result.get(keyValue);
        if (resultItem) {
            resultItem.push(mapper(item));
        }
        else {
            result.set(keyValue, [mapper(item)]);
        }
        return result;
    }, new Map());
};
export const arrayMapById = (array, idKey, idValue, mapper) => {
    return array.map((item) => {
        if (item[idKey] === idValue) {
            return mapper(item);
        }
        return item;
    });
};
//# sourceMappingURL=array-record.js.map